import { useTranslation } from 'react-i18next';
import { FOCUS_CLASS } from './stijl';

const RESET_ICON = 'filter_alt_off';

interface ResetKnopProps {
  onReset: () => void;
  /** Filters en sortering staan al op hun standaard (de pagina telt niet, CAP-7). */
  uitgeschakeld: boolean;
  /** Geen `title`-tooltip: voor modules die hover-only informatie verbieden (werkkwaliteit); de toegankelijke naam blijft. */
  zonderTooltip?: boolean;
}

/** Eén icoon dat de lijst terugzet zoals hij na verversen opent (§6). */
export function ResetKnop({ onReset, uitgeschakeld, zonderTooltip }: ResetKnopProps) {
  const { t } = useTranslation();
  const naam = t('tabel.standaardHerstellen');
  return (
    <button
      aria-label={naam}
      className={`inline-flex min-h-11 min-w-11 items-center justify-center rounded-[var(--radius-control)] border border-[var(--border)] bg-[var(--background)] text-[var(--foreground-muted)] hover:text-[var(--foreground)] disabled:cursor-not-allowed disabled:opacity-50 md:min-h-9 md:min-w-9 ${FOCUS_CLASS}`}
      disabled={uitgeschakeld}
      onClick={onReset}
      title={zonderTooltip ? undefined : naam}
      type="button"
    >
      <span aria-hidden="true" className="material-symbols-outlined text-[20px]">
        {RESET_ICON}
      </span>
    </button>
  );
}
